<div class="navbar-brand-box">
  <a routerLink="/" class="logo logo-dark">
    <span class="logo-sm">
      <img src="assets/images/brands/tsolife-ico-250x250.svg" alt="" height="35" />
    </span>
    <span class="logo-lg">
      <img
        [src]="
          community?.logoMedia?.url
            ? community!.logoMedia!.url
            : 'assets/images/brands/tsolife-logo-200x45.svg'
        "
        alt=""
        height="65"
      />
    </span>
  </a>
</div>
